import React from "react";
import wrapImg from "../../assets/images/shaw.png";
import burgerImg from "../../assets/images/bur-icon.png";

import blueBg from "../../assets/images/deal1.png";
import redBg from "../../assets/images/deal2.png";

const DealsSection = () => {
  return (
    <section id="deals-section">
      <div className="wrapper">
        <div className="deals-wrapper">
          {/* LEFT CARD */}
          <div className="deal-card blue" style={{ backgroundImage: `url(${blueBg})` }}>
            <div className="deal-content">
              <h3>
                Classic Chicken
                <br />
                Parmesan and Pasta
              </h3>
              <p>Breaded chicken over penne pasta, smothered in sauce and melted provolone. Topped with parmesan, romano and asiago cheese and a sprinkle of parsley, also served with a side of garlic bread.</p>
              <a href="/menu?section=pastaspecials&item=chickenparmesanandpasta" >ORDER YOURS →</a>
            </div>

            <img src={wrapImg} alt="Wrap" className="deal-image" />
          </div>

          {/* RIGHT CARD */}
          <div className="deal-card red" style={{ backgroundImage: `url(${redBg})` }}>
            <div className="deal-content">
              <h3>
                Make it a Fitchville 
                <br />
                Frank Platter
              </h3>
              <p>Take our loaded bacon and cheese long dog and turn it into a full meal by making it a platter!</p>
              <a href="/menu?section=handhelds&item=fitchvillefrank" >GRAB THE DEAL →</a>
            </div>

            <img src={burgerImg} width={482} height={362} alt="Burger" className="deal-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DealsSection;
